//接驳状态
export function pickColor(status){
    if(status === 0){
        return '#07C196'
    }
    if(status === 1){
        return '#FA4169'
    }
    else if(status === 3){
        return '#FF8E1D'
    }
    else if(status === 4){
        return '#1D1E2C'
    }
    else{
        return '#69707F'
    }
}
export function pickStatus(status){
    if(status === 0){
        return '待支付'
    }
    if(status === 1){
        return '待接单'
    }
    if(status === 2){
        return '待出行'
    }
    if(status === 3){
        return '行程中'
    }
    if(status === 4){
        return '已完成'
    }
    if(status === 98){
        return '已退票'
    }
    if(status === 99){
        return '已关闭'
    }
}
export default {
    pickColor,
    pickStatus
}


// WEBPACK FOOTER //
// ./src/common/js/pickCommon.js